<template>
    <div class="main">
        <iframe :src="url" width="100%" height="100%" border="0"></iframe>
    </div>
</template>

<script>

    export default {
        name: 'blsViewfile',

        data() {
            return {
                url: ''
            }
        },
        mounted() {
            this.url = this.$route.query.url

        }
    }
</script>

<style scoped>
    .main {
        height: 100%;
    }
</style>